// extracted by mini-css-extract-plugin
module.exports = {"container":"of","copy":"pf","field":"qf","error":"rf","disabled":"sf","termsContainer":"tf","termsHeading":"uf","termsCopy":"vf","submit":"wf","srOnly":"xf"};